import kr from '../kr/kr';
import Swiper from 'swiper/bundle';

export default class CategorySlider extends kr.Component {
    init()
    {
        this._canRunYoutube = false;
        this.els = {
            bind: this.$element.querySelector('.js_bind'),
            nav_prev: this.$element.querySelector('.js_bind-nav-prev'),
            nav_next: this.$element.querySelector('.js_bind-nav-next'),
        }

        const args = {
            loop: false,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        };

        if (this.els.nav_prev && this.els.nav_next) {
            args.navigation = {
                nextEl: this.els.nav_next,
                prevEl: this.els.nav_prev,
            }
        }

        this.slider = new Swiper(this.els.bind, args);

        for (let i in this.slider.slides) {
            if (!this.slider.slides.hasOwnProperty(i)) {
                continue;
            }
            const slide = this.slider.slides[i];
            if (slide.getAttribute('data-type') == 'youtube') {
                this.app.addJs("https://cdn.jsdelivr.net/npm/youtube-background@1.0.8/jquery.youtube-background.min.js", true, this._callback.bind(this));
            }
        }

        this._bind();
    }

    _bind() 
    {
        this.slider.on('slideChange', () => {
            const slide = this.slider.slides[this.slider.activeIndex];
            this._checkSlide(slide);
        });
    }

    _checkSlide(slide)
    {
        if (slide.getAttribute('data-type') == 'youtube' && this._canRunYoutube) {
            const youtube = slide.querySelector('[data-youtube]');
            if (!youtube) {
                return;
            }
            jQuery(youtube).youtube_background();
        } else if(slide.getAttribute('data-type') == 'video') {
            const video = slide.querySelector('video');
            
            if (!video) {
                return;
            }
            video.muted = true;
            video.play();
        }
    }

    _callback()
    {
        this._canRunYoutube = true;
        const slide = this.slider.slides[this.slider.activeIndex];
        this._checkSlide(slide);
    }
    //
}

kr.registerComponent('.js_category-slider', {
    component: CategorySlider
});
